import * as React from 'react';
import { SVGProps } from 'react';

const IconFileTransparentSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path d="M13 11v2h-2v-2h2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 9V7h-2v2H9V7H7v2h2v2H7v2h2v2H7v2h2v-2h2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2V9h2V7h-2v2h-2Zm0 2V9h-2v2H9v2h2v2h2v-2h2v-2h-2Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 3h-2v2H9V3H7v2H5V3H3v2h2v2H3v2h2v2H3v2h2v2H3v2h2v2H3v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2V9h2V7h-2V5h2V3h-2v2h-2V3h-2v2h-2V3Zm0 4V5h-2v2H9V5H7v2H5v2h2v2H5v2h2v2H5v2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v-2h-2v-2h2v-2h-2V9h2V7h-2V5h-2v2h-2Z"
    />
  </svg>
);
export default IconFileTransparentSizeM;
